import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, ApiError } from '../lib/api';
import { useAuth } from '../lib/auth';

export function ChangePasswordPage() {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const { refresh } = useAuth();
  const nav = useNavigate();

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (next !== confirm) { setErr('Passwörter stimmen nicht überein'); return; }
    if (next.length < 12) { setErr('Mindestens 12 Zeichen'); return; }
    setBusy(true); setErr('');
    try {
      await api.post('/auth/password/change', { currentPassword: current, newPassword: next });
      await refresh();
      nav('/');
    } catch (e) {
      setErr(e instanceof ApiError ? e.message : 'Fehler');
    } finally { setBusy(false); }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="card w-full max-w-md">
        <h1 className="text-xl font-bold text-rla-700 mb-2">Passwort ändern</h1>
        <p className="text-sm text-slate-600 mb-4">Wähle ein langes, einmaliges Passwort.</p>
        <form onSubmit={submit} className="space-y-3">
          <div><label className="label">Aktuell</label>
            <input type="password" className="input" required value={current} onChange={(e) => setCurrent(e.target.value)} autoComplete="current-password" /></div>
          <div><label className="label">Neu (min. 12)</label>
            <input type="password" className="input" required minLength={12} value={next} onChange={(e) => setNext(e.target.value)} autoComplete="new-password" /></div>
          <div><label className="label">Bestätigen</label>
            <input type="password" className="input" required value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" /></div>
          {err && <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-md p-3">{err}</div>}
          <button type="submit" disabled={busy} className="btn-primary w-full">
            {busy ? 'Ändere …' : 'Passwort ändern'}
          </button>
        </form>
      </div>
    </div>
  );
}
